$ = jQuery.noConflict();

// ── Random Stuff Posts accordion (mobile) ───────────────────────────────────
document.addEventListener('click', function(e) {
    var btn = e.target.closest('.rsp-accordion__header');
    if (!btn) return;
    var group = btn.closest('.rsp-accordion__group');
    var body = group.querySelector('.rsp-accordion__body');
    var isOpen = group.classList.contains('is-open');
    if (isOpen) {
        group.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        body.hidden = true;
    } else {
        group.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        body.hidden = false;
    }
});

// ── Client-side product search ──────────────────────────────────────────────
var _allProducts = [];
var _suggestionsHTML = '';

function _loadAllProducts(page) {
    page = page || 1;
    $.getJSON('/products.json?limit=250&page=' + page, function(data) {
        if (!data.products || data.products.length === 0) return;
        _allProducts = _allProducts.concat(data.products);
        if (data.products.length === 250) _loadAllProducts(page + 1);
    });
}

function _wordPrefixMatch(title, query) {
    var q = query.toLowerCase();
    return title.toLowerCase().split(/\s+/).some(function(word) {
        return word.indexOf(q) === 0;
    });
}

function _escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}

function _buildSearchResultsHTML(products, query) {
    var count = products.length;
    var safeQuery = _escapeHtml(query);
    var label = count + ' result' + (count !== 1 ? 's' : '') + ' for \u201C' + safeQuery + '\u201D';
    var html = '<div class="predictive-search">';
    html += '<div class="predictive-search-title"><h3 class="predictive-search-title__content">' + label + '</h3></div>';
    html += '<ul id="predictive-search-results" class="predictive-search__list">';
    products.slice(0, 10).forEach(function(p, i) {
        var img = p.images && p.images[0] ? p.images[0].src : '';
        if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2');
        var safeTitle = _escapeHtml(p.title);
        var safeHandle = _escapeHtml(p.handle);
        html += '<li id="search-result-' + i + '" class="predictive-search-item">';
        html += '<a class="predictive-search-item__link" href="/products/' + safeHandle + '">';
        html += '<div class="predictive-search__column predictive-search__column--image">';
        if (img) html += '<img class="predictive-search-item__image" src="' + _escapeHtml(img) + '" alt="' + safeTitle + '">';
        html += '</div>';
        html += '<div class="predictive-search__column predictive-search__column--center">';
        html += '<span class="predictive-search-item__title"><span class="predictive-search-item__title-text">' + safeTitle + '</span></span>';
        html += '</div></a></li>';
    });
    html += '</ul></div>';
    return html;
}

$(document).ready(function() {
    _loadAllProducts();

    // Store suggestions HTML once on load
    var sugEl = document.querySelector('.predictive-search-wrapper-grid .suggestions');
    if (sugEl) _suggestionsHTML = sugEl.outerHTML;

    $(document).on('submit', '#SearchDrawer .search-form', function(e) {
        e.preventDefault();
    });

    $(document).on('input', '[data-predictive-search-drawer-input]', function() {
        var query = $(this).val().trim();
        var grid = document.querySelector('.predictive-search-wrapper-grid');
        if (!grid) return;

        if (query.length === 0) {
            if (_suggestionsHTML) grid.innerHTML = _suggestionsHTML;
            return;
        }

        var filtered = _allProducts.filter(function(p) {
            return _wordPrefixMatch(p.title, query);
        });

        if (filtered.length > 0) {
            grid.innerHTML = _buildSearchResultsHTML(filtered, query);
        }
    });
});



function hide_body_overflow() {
    $("body").css('overflow', 'hidden')
}

function show_body_overflow() {
    $("body").css('overflow', 'auto')
}

function show_modal(selector) {
    $(selector).fadeIn(200)
    //hide_body_overflow()
}

function hide_modal(selector) {
    $(selector).fadeOut(200)
    //show_body_overflow()
}

function waitForElm(selector) {
    return new Promise(resolve => {

        const observer = new MutationObserver(mutations => {
            if ($(selector).length > 0) {
                observer.disconnect();
                resolve($(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// Función de validación de correo electrónico simple
function isValidEmail(email) {
    // Aquí puedes implementar una lógica de validación más sofisticada
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

$(document).ready(function() {

    // Blog articles accordions
    $(".article-listing").click(function() {
        $(this).find(".rte").slideToggle(200);
        $(this).find("h2").toggleClass("opened")
        if ($(this).find("h2").hasClass("opened")) {
            $(this).find(".read-more").hide()
        } else {
            $(this).find(".read-more").show()
        }
    })

    // Popup local open
    $(".popup-local-talina").click(() => {
        show_modal(".popup-local")
        hide_modal(".popup-variaciones")
    })

    // Close all square-popup
    $('.square-popup .close').click(() => {
        hide_modal(".square-popup")
    })

    // Popup color variations
    $(".product-selected-colors").click(() => {
        show_modal(".popup-variaciones")
        hide_modal(".popup-local")
    })

    // Popup productes personalitzats
    $(".productes-personalitzats-popup-trigger").click(() => {
        show_modal(".popup-personalitzats")
    })

    // Close all mid-width-popup
    $(".mid-width-popup .close").click(() => {
        hide_modal(".mid-width-popup")
    })

    $(".product-gifts .gift").click(function() {
        const product_id = $(this).data('id')
        console.log('adding to cart')
        console.log(product_id)
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {id:product_id, quantity:1},
            success: function(){
                console.log('added to cart')
                location.href="/cart";
            }
        });
    })

    // FAQS accordions
    $(".faq-container .question").click(function() {
        $(this).siblings(".answer").slideToggle(200);
    })

    // Random stuff page
    $(".faq-container .question").hover(function(e) {
        if (!$(this).siblings(".answer").is(":visible")) {
            $(this).siblings(".read-more").show();
            $(this).mousemove(function(e) {
                $(this).siblings(".read-more").css('left', e.clientX + 16)
                $(this).siblings(".read-more").css('top', e.clientY - 32)
            })
        }
    }, function(e) {
        $(this).siblings(".read-more").hide();
    })

    // Design yours form
    /*$(".form-design").submit(function() {

        if (!$("#submit-form-design-yours").hasClass("disabled")) return;
        

        if ($(".questions .q").last().hasClass("active")) {

            let answer = $("input[name=answer]").val()

            $(".questions .active + .answer").text(answer)
            $(".form-design input[name=answer]").val('')

            // 
            $("#submit-form-design-yours").removeClass("disabled")

            $(".questions .answer").each(function(index, el) {
                let answer = $(el).text()
                $(`.form-design [name=q${index}`).val(answer)
            })

            $(".form-design input[type=text]").attr('disabled', '')

            return false
        } else {

            let answer = $("input[name=answer]").val()

            $(".questions .active + .answer").text(answer)
            $(".questions .active").toggleClass("active answered").next().next().addClass("active")
        
            $(".form-design input[name=answer]").val('')

            return false
        }
    })*/

    // Search modal (close action)
    $(".close-search").click(() => {
        $(".search-bar__close").click()
    })

    // MOBILE
    
    function alignMobileCloseBtn() {
        var $wrapper = $(".mobile-nav-wrapper");
        var $btn = $wrapper.find(".mobile-nav__close-btn");
        var $firstItem = $wrapper.find(".mobile-nav__item").first();
        if (!$firstItem.length || !$btn.length) return;
        var wrapperTop = $wrapper.offset().top;
        var itemTop = $firstItem.offset().top;
        $btn.css("top", (itemTop - wrapperTop) + "px");
    }

    $(".site-header__menu").click(function() {
        var $wrapper = $(".mobile-nav-wrapper");
        var isOpen = $wrapper.is(":visible");
        if (isOpen) {
            $wrapper.fadeOut(300);
        } else {
            $wrapper.css({ display: 'flex', opacity: 0 });
            alignMobileCloseBtn();
            $wrapper.animate({ opacity: 1 }, 300);
        }
    })
    $(window).on("resize", alignMobileCloseBtn);
    $(".icon-menu-close, .mobile-nav__close-btn").click(function(e) {
        e.preventDefault();
        $(".mobile-nav-wrapper").fadeOut(300);
        $(".js-mobile-nav-toggle").addClass('mobile-nav--open').removeClass('mobile-nav--close');
        lockScroll();
    })

    // Search modal
    $(".search-bar__close.js-drawer-close").click(function() {
        $("body").css('overflow', 'auto');
    })

    // Product page variant default
    /* const val_color = jQuery(".single-option-selector").val()
    waitForElm(`.g-variant-color-detail [value="${val_color}"]`).then((elm) => {
        setTimeout(function() {
            $(`.g-variant-color-detail [value="${val_color}"]`).click()
        }, 1000)
    }); */


    // Fitxa producte
    jQuery("#SingleOptionSelector-0").change(function(e) {

        e.stopPropagation()

        // Format color value
        let selected_color = $(this).val()
        selected_color = selected_color.replaceAll(' + ', ' ')

        // Add or update color label
        if ($(".selected-color").length > 0) {
            $(".selected-color").replaceWith(`<p class="selected-color mb-0" style="margin-top: .75rem;">${selected_color}</p>`)
        } else {
            $(".g-variant-color-detail").after(`<p class="selected-color mb-0" style="margin-top: .75rem;">${selected_color}</p>`)
        }
        setTimeout(function() {
            // Enlarge wheren there is only one image left to 100vw
            if (jQuery(".product-single__media-wrapper:visible").length == 1) {
                jQuery(".product-single__media-wrapper").find("img").css('width', '100vw')
            }
        }, 500)
    })
    
    // About page
    $(".page-about .tabs .tab").click(function() {
        const content_id = $(this).data('tab-id')
        $(".page-about .tabs .tab").removeClass("active")
        $(this).addClass("active")

        $(".page-about .contents .content").removeClass("show")
        $(`.page-about .contents .content[data-content-id=${content_id}]`).addClass("show")
    })

    $(".page-about").mousemove(function(e) {
        if ($(".page-about .img:visible").length > 0) {
            $(`.page-about .text-block .img:visible`).css('left', e.clientX + 32)
            $(`.page-about .text-block .img:visible`).css('top', e.clientY + 32)
        } 
    })

    $(".page-about .text-block").hover(function() {
        if (window.innerWidth > 768) {
            const index = $(this).data('index')
            $(`.page-about .text-block[data-index=${index}] .img`).show()
        }
    }, function() {
        const index = $(this).data('index')
        $(`.page-about .text-block[data-index=${index}] .img`).hide()
    })

    

    // Random stuff page
    $(".template-blog .article-listing").hover(function(e) {
        if (!$(this).find("h2").hasClass("opened")) {
            $(this).find(".read-more").show();
            $(this).mousemove(function(e) {
                $(this).find(".read-more").css('left', e.clientX + 16)
                $(this).find(".read-more").css('top', e.clientY - 32)
            })
        }
        
    }, function(e) {
        $(this).find(".read-more").hide();
    })


    $(".thumbnails-wrapper").remove()

    // Submit NL
    if (window.innerWidth > 768) {
        setTimeout(function() {
            button = $(".subscribe button");
            button.insertAfter(".subscribe .klaviyo-form").addClass("new-nl-btn");
            button.remove()
        }, 2000)
    }

    $(document).on("click", ".new-nl-btn", function() {
        $(".subscribe input[type=submit]").click();
    })
    
    // Custom plugin form class
    waitForElm(".ql-font-nunito-sans").then((elm) => {
        setTimeout(function() {
            $(".subscribe").fadeOut(200)
        }, 3000)
    });

    waitForElm(".new-nl-btn").then((nl_btn) => {
        console.log(nl_btn)
        const text = nl_btn.text()
        console.log(text)
        nl_btn.text("")
        const span = $('<span class="epep"/>').text(text)
        console.log(span)
        nl_btn.append(span)
    })

    /* waitForElm("#frame_XgUjiUrJXIJ1G7HTaeOtuw").then((nl_btn) => {
        alert('YA')

        jQuery(".form-contact .submit").click(function() {
        
            fname = jQuery(".form-contact .name").val()
            femail = jQuery(".form-contact .email").val()
            fmessage = jQuery(".form-contact .message").text()
    
            alert(fname)
    
            jQuery("#wizard-validation-form input#form_input_0").val(fname)
            jQuery("#wizard-validation-form input#form_input_1").val(femail)
            jQuery(".formElement_2 textarea").text(fmessage)
    
            jQuery(".form_submit_div button").click()
        })
    }) */
    
    // Contact form
    


    

})



    




// Quantity stepper
$(document).on('click', '.quantity-stepper__minus', function() {
    var $input = $(this).closest('.quantity-stepper').find('[data-quantity-input]');
    var val = parseInt($input.val()) || 1;
    var min = parseInt($input.attr('min')) || 1;
    if (val > min) $input.val(val - 1).trigger('change');
});

$(document).on('click', '.quantity-stepper__plus', function() {
    var $input = $(this).closest('.quantity-stepper').find('[data-quantity-input]');
    var val = parseInt($input.val()) || 1;
    $input.val(val + 1).trigger('change');
});

// Scroll state
function updateScrolledHeader() {
    if (window.pageYOffset > 0) {
        $(".site-header").addClass("site-header--scrolled");
    } else {
        $(".site-header").removeClass("site-header--scrolled");
    }
}
updateScrolledHeader();

// Dropdown open → extend white background
function updateDropdownExtension() {
    var $openBtn = $('.site-header .site-nav--has-dropdown button[aria-expanded="true"]');
    if ($openBtn.length && $('.site-header').hasClass('site-header--scrolled')) {
        var $dropdown = $openBtn.closest('.site-nav--has-dropdown')
            .find('.site-nav__dropdown--left, .site-nav__dropdown--right').first();
        if ($dropdown.length) {
            var headerBottom = $('.site-header')[0].getBoundingClientRect().bottom;
            var dropdownBottom = $dropdown[0].getBoundingClientRect().bottom;
            var extension = Math.max(0, dropdownBottom - headerBottom);
            $('.site-header')[0].style.setProperty('--dropdown-extension', extension + 'px');
            $('.site-header').addClass('site-header--dropdown-open');
            return;
        }
    }
    $('.site-header').removeClass('site-header--dropdown-open');
}

$(document).on('click', '.site-header .site-nav--has-dropdown button', function() {
    var $dropdown = $(this).closest('.site-nav--has-dropdown')
        .find('.site-nav__dropdown--left, .site-nav__dropdown--right').first();
    $dropdown.css('opacity', '0');
    setTimeout(function() {
        updateDropdownExtension();
        $dropdown.css('opacity', '1');
    }, 80);
});

$(document).on('click', function(e) {
    if (!$(e.target).closest('.site-header .site-nav--has-dropdown').length) {
        $('.site-header').removeClass('site-header--dropdown-open');
    }
});


// Hide / show header on scroll
let current_height = window.pageYOffset;
window.onscroll = function() {
    updateScrolledHeader();

   /* if (window.pageYOffset > current_height) {
        // Scroll down
        $(".site-header").addClass("hide-header")

    } else {
        // Scroll up
        $(".site-header").removeClass("hide-header")

    } */
    current_height = window.pageYOffset;

    updateDropdownExtension();
  
   
    /* // About page Intent de canviar el color del text progessivament amb l'scroll
    if ($('.page-about').length > 0) {
      
        setTimeout(function() {
            const scrollY = window.scrollY + 100
            $(".text-block").each(function(index, el) {
                
                let text_block_top = $(el).offset().top
    
                console.log(index)
                console.log(el)
    
                console.log(scrollY)
                console.log(text_block_top)
    
                if (scrollY > text_block_top) {
                    console.log('supera')
                    
                    dist = scrollY - text_block_top
                    height = $(el).height()
                    
                    percent = ((dist / height) * 100 ) / 2
                 
                    $(el).find(".text").css('color', `hsla(51, 0%, 0%, ${percent})`)
                }
                
            })
        }, 50) 
    } */

}

$(".nl-trigger").click(function(e) {
    e.preventDefault();
    $(".subscribe").css('display', 'flex');
})

// Newsletter footer form → Klaviyo
$(document).off('click.footernl').on('click.footernl', '.footer-nl__btn', function(e) {
    e.preventDefault();
    var email = $('.footer-nl__input').val().trim();
    var privacy = document.getElementById('footer-nl-privacy').checked;
    var $btn = $(this);

    if (!email) {
        alert('Please enter your email.');
        return;
    }
    if (!privacy) {
        alert('Please accept the privacy policy.');
        return;
    }

    $btn.prop('disabled', true).text('Sending...');

    var formData = new FormData();
    formData.append('g', 'XcGaPX');
    formData.append('email', email);
    formData.append('$fields', '$consent');
    formData.append('$consent', 'email');

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        body: formData
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
        console.log('Klaviyo response:', data);
        if (data.success) {
            $btn.text('Done!');
            $('.footer-nl__input').val('');
            document.getElementById('footer-nl-privacy').checked = false;
        } else {
            $btn.prop('disabled', false).text('Subscribe');
            alert('Something went wrong. Please try again.');
        }
    })
    .catch(function(err) {
        console.log('Klaviyo error:', err);
        $btn.prop('disabled', false).text('Subscribe');
        alert('Something went wrong. Please try again.');
    });
});

// Size picker
$(document).on('click', '.size-picker__btn', function(e) {
    e.stopPropagation();
    var $btn = $(this);
    var value = $btn.data('value');
    var optionIndex = $btn.data('option-index');
    var sectionId = $btn.data('section-id');

    $btn.closest('.size-picker').find('.size-picker__btn').removeClass('size-picker__btn--active');
    $btn.addClass('size-picker__btn--active');

    // Update ProductSelect directly from product JSON
    var productData = JSON.parse($('#ProductJson-' + sectionId).html());
    var selectedOptions = {};
    $('.size-picker__btn--active').each(function() {
        var idx = $(this).data('option-index');
        selectedOptions[idx] = $(this).data('value');
    });

    var variant = productData.variants.find(function(v) {
        return Object.keys(selectedOptions).every(function(idx) {
            return v['option' + (parseInt(idx) + 1)] === selectedOptions[idx];
        });
    });

    if (variant) {
        $('#ProductSelect-' + sectionId).val(variant.id);
    }

    // Update hidden select for theme JS last
    var $select = $('.single-option-selector-' + sectionId).eq(optionIndex);
    $select.val(value).trigger('change');
});

// Product info accordion (mobile)
$(document).on('click', '.product-info__accordion-trigger', function(e) {
    e.stopPropagation();
    var $trigger = $(this);
    var $content = $trigger.next('.product-info__accordion-content');
    if ($content.is(':animated')) return;
    var isExpanded = $trigger.attr('aria-expanded') === 'true';
    $trigger.attr('aria-expanded', String(!isExpanded));
    $content.stop(true, true).slideToggle(200);
});
